import React from 'react';
import { Link } from 'react-router';

import Icon, { Icons } from '@shared/Icons/Icon';
import ExternalLink from '../ExternalLink';
import Container from '../Container';

import {
  container,
  column,
  mediumFont,
  listIcon,
  narrowContainer,
} from './styles.module.css';

const Row1ExtraInfo = ({ narrow }) => (
  <Container className={narrow ? narrowContainer : ''}>
    <div className={container}>
      <div className={column}>
        <h6>Company</h6>
        <ul>
          <li>
            <Link to="/about">About us</Link>
          </li>
          <li>
            <ExternalLink
              follow
              href="https://angel.co/company/lets-do-this/jobs"
            >
              Careers
            </ExternalLink>
          </li>
          <li>
            <Link to="/brand-partnerships">Brand partnerships</Link>
          </li>
          <li>
            <ExternalLink href="mailto:support@letsdothis.com">
              Contact Us
            </ExternalLink>
          </li>
        </ul>
      </div>

      <div className={column}>
        <h6>Get to know us</h6>
        <ul>
          <li>
            <ExternalLink
              follow
              href="https://www.instagram.com/letsdothis.com_"
            >
              <Icon className={listIcon} icon={Icons.INSTAGRAM.GREY} />
              Follow our Instagram
            </ExternalLink>
          </li>
          <li>
            <ExternalLink
              follow
              href="https://www.strava.com/clubs/252814/discussion"
            >
              <Icon className={listIcon} icon={Icons.STRAVA.GREY} />
              Join our Strava Club
            </ExternalLink>
          </li>
          <li>
            <ExternalLink follow href="https://www.letsdothis.com/blog/">
              <Icon className={listIcon} icon={Icons.BLOG} />
              Read blog articles
            </ExternalLink>
          </li>
          <li>
            <ExternalLink follow href="https://store.letsdothis.com">
              <Icon className={listIcon} icon={Icons.STORE} />
              Visit the LDT Store
            </ExternalLink>
          </li>
        </ul>
      </div>

      <div className={column}>
        <h6>Policies</h6>
        <ul>
          <li>
            <Link to="/terms">Terms of use</Link>
          </li>
          <li>
            <Link to="/payments">Payment terms</Link>
          </li>
          <li>
            <Link to="/refunds">Refund policy</Link>
          </li>
          <li>
            <Link to="/privacy">Privacy</Link>
          </li>
        </ul>
      </div>

      <div className={column}>
        <h6>Offices</h6>
        <ul>
          <li>
            <p>
              <span className={mediumFont}>San Francisco, USA</span>
              <span>548 Market St, PMB 40664, CA 94104-5401</span>
              <span>Registration number 6671849</span>
            </p>
          </li>
          <li>
            <p>
              <span className={mediumFont}>London, UK</span>
              <span>90 High Holborn, 4th Floor, WC1V 6LJ</span>
              <span>Registration number 10083277</span>
            </p>
          </li>
        </ul>
      </div>
    </div>
  </Container>
);

export default Row1ExtraInfo;
